module.exports = __webpack_public_path__ + "public/1.0.1_626420/img/ANSI_ESD S20.20-2014.3b1954a0.png";